import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Link as MuiLink,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const exampleCharacters = [
  {
    level: 60,
    characterName: "Legolas",
    playerName: "****elf",
    server: "Vox",
    guild: "Rangers of the North",
    class: "Ranger",
    race: "Wood Elf",
    createdAt: "2024-01-15"
  },
  {
    level: 55,
    characterName: "Gandalf",
    playerName: "****zard",
    server: "Vox",
    guild: "White Council",
    class: "Wizard",
    race: "Human",
    createdAt: "2024-01-14"
  },
  {
    level: 52,
    characterName: "Gimli",
    playerName: "****warf",
    server: "Vox",
    guild: "Miners of Moria",
    class: "Warrior",
    race: "Dwarf",
    createdAt: "2024-01-13"
  }
];

const LandingPage = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }}>
      <Box sx={{ maxWidth: 1200, margin: '0 auto', padding: 3, flex: 1 }}>
        <Typography variant="h3" gutterBottom align="center">
          EQ Emblem
        </Typography>
        <Typography variant="h5" gutterBottom align="center" sx={{ mb: 4 }}>
          Track and share your EverQuest characters
        </Typography>
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            onClick={() => loginWithRedirect()}
          >
            Login to Add Your Characters
          </Button>
        </Box>

        <Typography variant="h6" gutterBottom>
          Example Character Database
        </Typography>
        
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Level</TableCell>
                <TableCell>Character</TableCell>
                <TableCell>Player</TableCell>
                <TableCell>Server</TableCell>
                <TableCell>Guild</TableCell>
                <TableCell>Class</TableCell>
                <TableCell>Race</TableCell>
                <TableCell>Created</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {exampleCharacters.map((character, index) => (
                <TableRow key={index}>
                  <TableCell>{character.level}</TableCell>
                  <TableCell>{character.characterName}</TableCell>
                  <TableCell>{character.playerName}</TableCell>
                  <TableCell>{character.server}</TableCell>
                  <TableCell>{character.guild}</TableCell>
                  <TableCell>{character.class}</TableCell>
                  <TableCell>{character.race}</TableCell>
                  <TableCell>{new Date(character.createdAt).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box 
        component="footer" 
        sx={{ 
          py: 3, 
          px: 2,
          mt: 'auto',
          backgroundColor: 'background.paper',
          borderTop: 1,
          borderColor: 'divider'
        }}
      >
        <Typography variant="body2" color="text.secondary" align="center">
          <Link to="/privacy" style={{ color: 'inherit', textDecoration: 'none' }}>
            Privacy Policy
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default LandingPage; 